import React from 'react'
import Button from '../../components/General/Button'
import { ISuscriber } from 'safe'
import { transformDate } from '../../utils/utils'

const SubscriberView = ({ onClose, subscriber }: { onClose: () => void; subscriber: ISuscriber }) => {
  const frequencyOptions = {
    monthly: 'Mensual',
    weekly: 'Semanal',
    biweekly: 'Quincenal',
    quarterly: 'Trimestral',
    annual: 'Anual',
  }

  return (
    <div className="gap-y-6 flex flex-col">
      {/* Header */}
      <div className="col-span-12" style={{ fontWeight: 500, fontSize: '18px' }}>
        Vista de suscriptor
      </div>

      {/* Client Information Section */}
      <div>
        <div className="col-span-12" style={{ fontWeight: 500, marginBottom: '16px' }}>
          Información del Cliente
        </div>

        <div className="bg-gray-50 dark:bg-gray-800 rounded-lg p-4 space-y-3">
          <div>
            <label className="text-xs text-gray-500 dark:text-gray-400 block mb-1">
              Nombre
            </label>
            <p className="text-sm text-gray-900 dark:text-white font-medium">
              {subscriber?.name || '-'}
            </p>
          </div>

          <div className="grid grid-cols-2 gap-4">
            <div>
              <label className="text-xs text-gray-500 dark:text-gray-400 block mb-1">
                Tipo de Documento
              </label>
              <p className="text-sm text-gray-900 dark:text-white font-medium">
                {subscriber?.documentType || '-'}
              </p>
            </div>

            <div>
              <label className="text-xs text-gray-500 dark:text-gray-400 block mb-1">
                Número de Documento
              </label>
              <p className="text-sm text-gray-900 dark:text-white font-medium">
                {subscriber?.document || '-'}
              </p>
            </div>
          </div>

          <div className="grid grid-cols-2 gap-4">
            <div>
              <label className="text-xs text-gray-500 dark:text-gray-400 block mb-1">
                Email
              </label>
              <p className="text-sm text-gray-900 dark:text-white font-medium">
                {subscriber?.email || '-'}
              </p>
            </div>

            <div>
              <label className="text-xs text-gray-500 dark:text-gray-400 block mb-1">
                Teléfono
              </label>
              <p className="text-sm text-gray-900 dark:text-white font-medium">
                {subscriber?.phone || '-'}
              </p>
            </div>
          </div>
        </div>
      </div>

      {/* Subscription Information Section */}
      <div>
        <div className="col-span-12" style={{ fontWeight: 500, marginBottom: '16px' }}>
          Información de la Suscripción
        </div>

        <div className="bg-gray-50 dark:bg-gray-800 rounded-lg p-4 space-y-3">
          {subscriber?.subscriptions && subscriber.subscriptions.length > 0 ? (
            subscriber.subscriptions.map((subscription, index) => (
              <div key={index} className="space-y-3 pb-3 border-b border-gray-200 dark:border-gray-700 last:border-b-0 last:pb-0">
                <div className="grid grid-cols-2 gap-4">
                  <div>
                    <label className="text-xs text-gray-500 dark:text-gray-400 block mb-1">
                      Nombre de la Suscripción
                    </label>
                    <p className="text-sm text-gray-900 dark:text-white font-medium">
                      {subscription?.description || '-'}
                    </p>
                  </div>

                  <div>
                    <label className="text-xs text-gray-500 dark:text-gray-400 block mb-1">
                      Estado
                    </label>
                    <div className="flex items-center">
                      <span
                        className={`inline-flex items-center px-3 py-1 rounded-full text-xs font-medium ${
                          subscription?.active
                            ? 'bg-green-100 text-green-800 dark:bg-green-900 dark:text-green-200'
                            : 'bg-red-100 text-red-800 dark:bg-red-900 dark:text-red-200'
                        }`}
                      >
                        {subscription?.active ? 'Activo' : 'Inactivo'}
                      </span>
                    </div>
                  </div>
                </div>

                <div className="grid grid-cols-2 gap-4">
                  <div>
                    <label className="text-xs text-gray-500 dark:text-gray-400 block mb-1">
                      Fecha de Inicio
                    </label>
                    <p className="text-sm text-gray-900 dark:text-white font-medium">
                      {transformDate(subscription?.startDate) || '-'}
                    </p>
                  </div>

                  <div>
                    <label className="text-xs text-gray-500 dark:text-gray-400 block mb-1">
                      Fecha de Fin
                    </label>
                    <p className="text-sm text-gray-900 dark:text-white font-medium">
                      {transformDate(subscription?.endDate) || '-'}
                    </p>
                  </div>
                </div>

                <div>
                  <label className="text-xs text-gray-500 dark:text-gray-400 block mb-1">
                    Frecuencia de Pago
                  </label>
                  <p className="text-sm text-gray-900 dark:text-white font-medium">
                    {frequencyOptions[subscription?.frequency] || '-'}
                  </p>
                </div>
              </div>
            ))
          ) : (
            <p className="text-sm text-gray-500 dark:text-gray-400 text-center py-4">
              No hay suscripciones asociadas
            </p>
          )}
        </div>
      </div>

      <div
        style={{ height: 1, width: '100%', backgroundColor: '#CFCFCF' }}
        className="col-span-12 mt-3"
      ></div>

      {/* Action Button */}
      <div className="col-span-12 h-full flex flex-row mt-4">
        <div className="w-full">
          <Button type="outline" classes="w-full" onClick={onClose}>
            Cerrar
          </Button>
        </div>
      </div>
    </div>
  )
}

export default SubscriberView
